export default {
      id: "pay_pci-usage",
      viewBox: "0 0 53 35",
      url: __webpack_public_path__ + "sprite.svg#pay_pci",
      toString: function () {
        return this.url;
      }
    }